var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 88,
    viewBox: "0 0 64 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5187 64.4271L54.1486 16.5149L42.8593 39.7279L42.8579 39.7307L20.2977 86.8839L15.4965 77.7211L1.62186 49.1923L18.659 65.0441C20.1165 66.4002 22.4465 66.1044 23.5187 64.4271ZM20.5117 87.2925L20.5112 87.2915C20.5114 87.2918 20.5116 87.2921 20.5117 87.2925L20.3071 87.3997L20.5117 87.2925Z",
    fill: "#DC4D4D",
    stroke: "#DC4D4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.272656,
    y: -0.073053,
    width: 1.8591,
    height: 0.392187,
    transform: "matrix(0.515547 -0.856861 0.874891 0.48432 59.6208 6.65699)",
    fill: "#DC4D4D",
    stroke: "#DC4D4D",
    strokeWidth: 0.392187
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.070465,
    y: 0.262997,
    width: 0.915148,
    height: 0.392187,
    transform: "matrix(-0.515547 0.856861 0.874891 0.48432 62.4236 1.34902)",
    fill: "#DC4D4D",
    stroke: "#DC4D4D",
    strokeWidth: 0.392187
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0490492,
    y: 0.183067,
    width: 0.272993,
    height: 0.51138,
    transform: "matrix(-0.515547 0.856861 0.874891 0.48432 63.2276 0.0523755)",
    fill: "#DC4D4D",
    stroke: "#DC4D4D",
    strokeWidth: 0.272993
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigStar);
export default __webpack_public_path__ + "static/media/big-star.b4c4a7cef0c8b20561879e3fa87ed7b9.svg";
export { ForwardRef as ReactComponent };